<template>
  <div class="card dash-card headercard" style="margin-top:2px; height:560px;">
    <LamboPreOwnedHeader :dashdata="dashdata" />

    <div class="card-body p-0 m-0">
      <div class="il-table">
        <div class="i-row">

          <div class="i-cell col-2">
            <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('1. Web Check - POL - Check')" :isHeader="true" />
            <titleunderline />
            <div class="dash-card-inner">
              <div class="row no-gutters">
                <div class="col-12">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('01.7 Was the quality of the pictures of the enquiry model adequate?')" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('01.8 Please comment: Was it easy and customer-friendly to find a pre-owned vehicle?')" />
                </div>
              </div>
            </div>
          </div>

          <div class="i-cell col-4">
            <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('2. Web Enquiry Reply')" :isHeader="true" />
            <titleunderline />

            <div class="dash-card-inner">
              <div class="row no-gutters">
                <div class="col-6">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('02.2 When was your first personal contact by the dealership?')" :noLetterSpacing="true" />
                  <tableitem :space="true" />
                </div>
                <div class="col-6">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('02.3.1.1 If you were contacted by e-mail, did the dealer use the Lamborghini Logo in the e-mail?')" :noLetterSpacing="false" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('02.3.2 Did the dealer use a personalised e-mail, so that it met the following quality standards?')" :noLetterSpacing="true" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('02.4 The operator introduced him/herself giving name or surname?')" :noLetterSpacing="true" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('02.6 Please comment the enquiry reply. Was it quick and customer-friendly?')" :noLetterSpacing="true" />
                </div>
              </div>
            </div>
          </div>

          <div class="i-cell col-4">
            <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('3. Web Enquiry Offer') || getKpiByString('3. Enquiry Offer')" :isHeader="true" />
            <titleunderline />

            <div class="dash-card-inner">
              <div class="row no-gutters">
                <div class="col-6">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('03.1 Did the dealer propose an appointment to show you the car?')" :noLetterSpacing="true" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('03.1.2 When were you invited to see the car?')" :noLetterSpacing="true" />
                </div>
                <div class="col-6">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('03.2 Please comment: Did everything meet your expectations?')" :noLetterSpacing="true" />
                </div>
              </div>
            </div>
          </div>

          <div class="i-cell col-2">
            <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('4. Showroom environment')" :isHeader="true" />
            <titleunderline />
            <div class="dash-card-inner">
              <div class="row no-gutters">
                <div class="col-12">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('2. Web Enquiry Reply')" />
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import performanceitem from './PerformanceItem'
  import tableitem from './TableItem.vue'
  import titleunderline from './TitleUnderline'
  import LamboPreOwnedHeader from './LamboPreOwnedHeader'
  import KpiMixin from '@/mixins/lambo/KpiMixin';

  export default {
    components: {
      performanceitem,
      tableitem,
      titleunderline,
      LamboPreOwnedHeader
    },

    mixins: [ KpiMixin ]
  }
</script>

<style scoped>
  .dash-card >>> .kpitable {
    max-width: 208px;
  }
    
</style>
